abstract class Type {

  public getTypeId(): number {
    return Object.getPrototypeOf(this).constructor.companyTypeId;
  }

  public isSelectable(): boolean {
    return Object.getPrototypeOf(this).constructor.isSelectable;
  }
}

export { Type }
